// extracted by mini-css-extract-plugin
export default {"buttons":"balneos_buttons__pLr6u","footer":"balneos_footer__ljp0D","button":"balneos_button__Lsvvf"};